import {
  type ComponentProps,
  type JSXElement,
  Show,
  splitProps
} from 'solid-js';
import {
  type PermissionRequirements,
  isAuthorized
} from '~/components/Authorization/utils';

// Raw props as inferred from Solid's <Show />
type RawShowProps = ComponentProps<typeof Show>;

// Normalize them for our wrapper:
// - remove `when` and `keyed`,
// - reintroduce them as *optional*.
type NormalizedShowProps = Omit<RawShowProps, 'when' | 'keyed'> & {
  when?: RawShowProps['when'];
  keyed?: boolean;
};

export type ShowIfAuthorizedProps = NormalizedShowProps & {
  permissions: PermissionRequirements;
};

export default function ShowIfAuthorized(
  props: ShowIfAuthorizedProps
): JSXElement {
  const [local, showProps] = splitProps(props, ['permissions', 'when']);

  const effectiveWhen =
    local.when === undefined ? (true as RawShowProps['when']) : local.when;

  return (
    <Show
      // cast only for the internal call – external API stays nice
      {...(showProps as RawShowProps)}
      when={isAuthorized(local.permissions) && effectiveWhen}
    />
  );
}
